import './js/app.js'

//http://mherman.org/blog/2017/01/05/token-based-authentication-with-angular/#.Wv0r24gvwdU
//https://webpack.js.org/guides/getting-started/
//http://blogs.quovantis.com/json-web-token-jwt-with-web-api/


// WEBPACK FOOTER //
// ./src/index.js